import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const getAll = () => {
    return vdkHappinessPortalApi.get("/role/get-all");
};
const roleApi = {
    getAll
};
export default roleApi;
